import * as StorageService from "./storage.service";
import { isBlockedReturnUrl } from "./location.manager";
var LocationService = /** @class */ (function () {
    function LocationService(location) {
        this.location = location;
        this.loginStorage = StorageService.withPrefix("whispeer.login");
    }
    LocationService.prototype.loadInitialURL = function () {
        var returnURL = this.loginStorage.get("returnUrl");
        if (returnURL && !isBlockedReturnUrl(returnURL)) {
            this.location.go(returnURL);
            this.loginStorage.remove("returnUrl");
        }
        if (isBlockedReturnUrl(window.top.location.pathname)) {
            this.location.go("/main");
        }
    };
    return LocationService;
}());
export default LocationService;



//////////////////
// WEBPACK FOOTER
// ./js/services/location.service.ts
// module id = cIyf
// module chunks = 1